import { createRouter, createWebHistory } from 'vue-router'
import Index from '../views/IndexComponent.vue'
import AboutComponent from '@/views/AboutComponent.vue'
import ContactComponent from '@/views/ContactComponent.vue'
import FaqComponent from '@/views/FaqComponent.vue'
import ServiceComponent from '@/views/ServiceComponent.vue'
import DigitalOperationsManagementComponent from '@/views/DigitalOperationsManagementComponent.vue'
import ServiceFormComponent from '@/views/ServiceFormComponent.vue'
import DigitalSalesComponent from '@/views/DigitalSalesComponent.vue'
import SupportImprovementComponent from '@/views/SupportImprovementComponent.vue'
import BrandingIdentityComponent from '@/views/BrandingIdentityComponent.vue'
import PrivacyPolicyComponent from '@/views/PrivacyPolicyComponent.vue'

// 🔥 IMPORTA TU 404 COMPONENT
import NotFoundComponent from '@/views/NotFoundComponent.vue'

// Define las rutas de la aplicación
const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index
  },
  {
    path: '/nosotros',
    name: 'About',
    component: AboutComponent
  },
  {
    path: '/contacto',
    name: 'Contact',
    component: ContactComponent
  },
  {
    path: '/servicios',
    name: 'Services',
    component: ServiceComponent
  },
  {
    path: '/faqs',
    name: 'Faqs',
    component: FaqComponent
  },
  {
    path: '/servicios/gestion-organizacion-digital',
    name: 'DigitalOperationsManagement',
    component: DigitalOperationsManagementComponent
  },
  {
    path: '/servicios/ventas-digitales',
    name: 'DigitalSales',
    component: DigitalSalesComponent
  },
  {
    path: '/servicios/soporte-optimizacion-continua',
    name: 'SupportOptimization',
    component: SupportImprovementComponent
  },
  {
    path: '/servicios/branding-identidad-marca',
    name: 'BrandingIdentity',
    component: BrandingIdentityComponent
  },
  {
    path: '/servicios/gestion-organizacion-digital/formulario',
    name: 'ServiceFormDOM',
    component: ServiceFormComponent
  },
  {
    path: '/servicios/ventas-digitales/formulario',
    name: 'ServiceFormSales',
    component: ServiceFormComponent
  },
  {
    path: '/servicios/presencia-profesional/formulario',
    name: 'ServiceFormPresence',
    component: ServiceFormComponent
  },
  {
    path: '/servicios/soporte-optimizacion-continua/formulario',
    name: 'ServiceFormSupport',
    component: ServiceFormComponent
  },
  {
    path: '/servicios/branding-identidad-marca/formulario',
    name: 'ServiceFormBranding',
    component: ServiceFormComponent
  },
  {
    path: '/aviso-privacidad',
    name: 'PrivacyPolicy',
    component: PrivacyPolicyComponent
  },

  // 🔥 404 SIEMPRE AL FINAL
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFoundComponent
  }
]

// Crea una instancia del enrutador con el historial en modo "history"
const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router